"use client";

import { motion } from "framer-motion";

interface WelcomeMessageProps {
  message?: string | null;
  theme?: "light" | "dark";
}

function splitHeadline(text: string) {
  const words = text.split(/\s+/);
  if (words.length <= 2) return { top: text, bottom: "" };

  const targetLen = Math.floor(text.length * 0.45);
  let topWords = 1;
  let currentLen = words[0].length;

  for (let i = 1; i < words.length - 1; i++) {
    if (currentLen + 1 + words[i].length > targetLen) break;
    currentLen += 1 + words[i].length;
    topWords = i + 1;
  }

  return {
    top: words.slice(0, topWords).join(" "),
    bottom: words.slice(topWords).join(" "),
  };
}

export function WelcomeMessage({ message, theme = "light" }: WelcomeMessageProps) {
  const displayMessage = message || "Hello! How can I assist you today?";
  const { top, bottom } = splitHeadline(displayMessage);
  const isDark = theme === "dark";

  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.4 }}
    >
      <div className="max-w-md">
        <p
          className={
            isDark
              ? "text-xl text-neutral-100"
              : "text-xl text-neutral-900"
          }
        >
          {top}
        </p>
        {bottom && (
          <p
            className={
              isDark
              ? "text-xl text-neutral-500"
              : "text-xl text-neutral-400"
            }
          >
            {bottom}
          </p>
        )}
      </div>
    </motion.div>
  );
}
